/**
 * Pipeline Block.
 * 
 */

/**
 * Desktop: Expand-collapse functionality of Pipeline item content.
 * Mobile: Expand-collapse functionality of Pipeline item content.
 */

let 
	$window = $(window),
	$excolButtons = $('.item-info__excol-btn.button-excol'),
	$myBtn,
	$myContent,
	$currBtn,
	$currContent,
	$myBlock,
	$currBlock;

function initExColButtons() {
	// console.log('PIPELINE: initExColButtons()');

	$excolButtons.on('click', function() {
		// console.log('CLICK: '+$(this));
		$myBtn = $(this);
		$myContent = $myBtn.parent().parent().parent().next();
		$currBtn = $excolButtons.filter('.expanded');
		$currContent = $currBtn.parent().parent().parent().next();
		$myContent.slideDown({
			start: function () {
				$(this).css({
					display: "flex"
				});
			}
		});
		  
		$myBlock = $(this).closest('.pipeline-block__target-block');
		$currBlock = $currBtn.closest('.pipeline-block__target-block');
		if ($myBtn.hasClass('expanded')) {
			// Collapse this Value.
			$myBtn.removeClass('expanded');
			$myContent.slideUp(300);
			var intervalId = window.setInterval(function(){
				setLogoCellHeight($myBlock);
			}, 10);
			setTimeout(() => {
				clearInterval(intervalId);
			}, 300);
		} else {
			// Collapse current expanded Value, expand this value.
			$currBtn.removeClass('expanded');
			$currContent.slideUp(300);
			$myBtn.addClass('expanded');
			$myContent.slideDown(300);
			var intervalId = window.setInterval(function(){
				setLogoCellHeight($myBlock);
				if ($myBlock != $currBlock) {
					setLogoCellHeight($currBlock);
				}
			}, 10);
			setTimeout(() => {
				clearInterval(intervalId);
			}, 300);
		}
	});
}

function setLogoCellHeight($block = null) {
	// console.log('PIPELINE: setLogoCellHeight()');
	let
		$myLogoCells = $('.chart-cell.has-logo');

	if ($block) {
		$myLogoCells = $block.find('.chart-cell.has-logo');
	}

	$myLogoCells.each(function(i) {
		let $myTargetBlock = $(this).closest('.pipeline-block__target-block');
		$(this).find('.pipeline-rights-logo').height($myTargetBlock.height());
	});
}

function initLogoCells() {
	// console.log('PIPELINE: initLogoCells()');

	$window.on('resize', function() {
		if ($window.width() >= 1024) {
			setLogoCellHeight();
		}
	});
}

exports.init = function () {
	// console.log('PIPELINE: exports.init');
	// Run init methods...

	initExColButtons();
	setLogoCellHeight();
	initLogoCells();
};